module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("eat•ing dis•or•der")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("(e′tĭng dĭs-ôr′dƏr)►")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("n.")]), _vm._v(" "), _c('strong', [_vm._v("1.")]), _vm._v(" Serious, potentially life-threatening, biologically based mental illness, usually characterized by daily functioning affected by disordered body image, a preoccupation with and anxiety related to food and eating, and disordered eating.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493bb066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm2.vue
// module id = 78
// module chunks = 0